module.exports = __webpack_public_path__ + "static/media/Marvel-01.f7063c0e.svg";